import React, { Component } from 'react';
import { Icon } from 'react-icons-kit';
import {question} from 'react-icons-kit/fa/question'

import './Map.css';

declare var CONFIGURATIONS;

class Map extends Component {

	render() {
		return (<div className='visor-wrapper'>
			<div className='map' id='map'>
			</div>
			<div className='map-help-guide' title='Manual de uso'>
				<a href={CONFIGURATIONS.guide_url} target='_blank' rel='noopener noreferrer'><Icon size={'28px'} icon={question}/></a>
			</div>
		</div>);
	}
}

export default Map;
